import {Component, EventEmitter, Output} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Customer} from '../../domain/customer';

@Component({
  selector: 'sg-order',
  animations: [
    trigger('myfirstanimation', [
      state('small', style({
        height: '0px',
      })),
      state('large', style({
        height: '320px',
      })),
      transition('small <=> large', animate('300ms ease-in')),
    ]),
  ],
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss']
})
export class OrderComponent {

  @Output() backButton = new EventEmitter();
  @Output() orderformChange = new EventEmitter();

  constructor() {
    this.state = 'small';
    this.customer = {
      name: null,
      email: null,
      street: null,
      postalCode: null,
      place: null,
      name2: null,
      email2: null,
      street2: null,
      postalCode2: null,
      place2: null
    };
  }

  customer: Customer = null;
  state = 'small';
  showConfirmation = true;

  toggle() {
    this.state = (this.state === 'small' ? 'large' : 'small');
  }

  processCustomer() {
    // console.log('bestel gedrukt');
    // console.log('naam : ' + this.customer.name);
    // console.log('e-mail : ' + this.customer.email);
    // console.log('straat : ' + this.customer.street);
    // console.log('postcode : ' + this.customer.postalCode);
    // console.log('plaats : ' + this.customer.place);
  }
}
